<div class="signup-page min-h-screen bg-white font-inter text-slate-950">
  <div class="grid min-h-screen lg:grid-cols-[2fr_3fr]">

    <!-- Left: Dark branding panel -->
    <div class="auth-brand-panel relative hidden overflow-hidden bg-slate-950 lg:flex lg:flex-col">
      <div
        class="pointer-events-none absolute inset-0 bg-gradient-to-br from-black/80 via-black/75 to-black/90">
      </div>
      <div class="pointer-events-none absolute -right-24 -top-24 h-96 w-96 rounded-full bg-primary-600/10 blur-3xl">
      </div>
      <div class="pointer-events-none absolute -bottom-32 -left-16 h-80 w-80 rounded-full bg-primary-400/10 blur-3xl">
      </div>

      <div class="relative flex h-full flex-col justify-between px-10 py-12 xl:px-16">

        <a routerLink="/" class="inline-flex items-center gap-3">
          <img src="assets/brand/logo.svg" width="40" height="40" alt="FormOps logo"
            class="h-10 w-10 shrink-0 rounded-2xl bg-white p-1.5 shadow-lg shadow-black/20" />
          <div>
            <p class="text-h6 text-white">FormOps</p>
            <p class="text-caption text-slate-400">AI Workflow Platform</p>
          </div>
        </a>

        <div class="flex flex-col gap-4">
          <p class="text-body3 font-medium uppercase tracking-widest text-primary-400">Get Started</p>
          <h1 class="text-h2 text-white">Welcome!</h1>
          <p class="text-body1 text-slate-400">
            Explore our intuitive dashboard and set up your account in just a few clicks.
          </p>
        </div>

        <div class="flex flex-col gap-8">
          <blockquote class="text-body2 italic leading-relaxed text-slate-300">
            "Great system — saves loads of time building forms and automating workflows. Highly recommended!"
          </blockquote>
          <div class="flex items-center gap-3">
            <div
              class="flex h-10 w-10 items-center justify-center rounded-full bg-primary-600/30 text-body3 font-semibold text-primary-300">
              JD
            </div>
            <div>
              <p class="text-body2 font-medium text-white">Jane Doe</p>
              <p class="text-body3 text-slate-400">Product Manager</p>
            </div>
          </div>

          <div class="flex flex-col gap-3">
            <div class="flex gap-6 text-body3 text-slate-500">
              <a routerLink="/" class="transition-colors hover:text-slate-300">Terms</a>
              <a routerLink="/" class="transition-colors hover:text-slate-300">Privacy Policy</a>
              <a routerLink="/login" class="transition-colors hover:text-slate-300">Sign in</a>
            </div>
            <p class="text-caption text-slate-600">© {{ currentYear }} FormOps. All rights reserved.</p>
          </div>
        </div>

      </div>
    </div>

    <!-- Right: Form panel -->
    <div class="flex flex-col justify-center bg-white px-6 py-12 sm:px-10 lg:px-16 xl:px-24">
      <div class="mx-auto flex w-full max-w-lg flex-col gap-10">

        <a routerLink="/" class="inline-flex items-center gap-3 lg:hidden">
          <img src="assets/brand/logo.svg" width="40" height="40" alt="FormOps logo"
            class="h-10 w-10 shrink-0 rounded-2xl bg-white p-1.5 shadow-lg shadow-black/20" />
          <div>
            <p class="text-h6 text-slate-950">FormOps</p>
            <p class="text-caption text-slate-500">AI Workflow Platform</p>
          </div>
        </a>

        <div class="flex flex-col gap-8">
          <div class="flex flex-col gap-2">
            <h2 class="text-h3 font-light text-slate-950">Create your account</h2>
            <p class="text-body1 text-slate-500">
              Sign up to start building smarter forms and AI-powered insights.
            </p>
          </div>

          <button
            type="button"
            class="flex w-full cursor-pointer items-center justify-center gap-3 rounded-xl border border-neutral-300 bg-white px-4 py-3 text-body2 font-medium text-neutral-900 transition-colors duration-200 hover:bg-neutral-50 active:bg-neutral-100 disabled:cursor-not-allowed disabled:opacity-60"
            (click)="onGoogleSignInClicked()">
            <app-svg-icon src="assets/icons/social/google.svg" [size]="24" />
            <span>Sign in with Google</span>
          </button>

          <div class="flex items-center gap-4">
            <div class="h-px flex-1 bg-neutral-200"></div>
            <span class="text-body3 text-neutral-500">or</span>
            <div class="h-px flex-1 bg-neutral-200"></div>
          </div>

          <form [signalForm]="signupForm">
            <div class="flex flex-col gap-5">

              <lib-signal-text-field [formField]="signupForm.name" label="Name"
                placeholder="Jane Doe" autocomplete="name" />

              <lib-signal-text-field [formField]="signupForm.companyName" label="Company name"
                placeholder="Acme Corp" autocomplete="organization" />

              <lib-signal-text-field [formField]="signupForm.email" label="Email" inputType="email"
                placeholder="you@company.com" autocomplete="email" />

              <lib-signal-text-field [formField]="signupForm.password" label="Password" inputType="password"
                placeholder="Min. 8 characters" autocomplete="new-password"
                hint="Must include uppercase, lowercase, and a number" />

              <div class="pt-2">
                <lib-signal-button
                  [loading]="signupState.loading()"
                  [disabled]="signupState.loading()"
                  [fullWidth]="true"
                  (clicked)="onSubmit()">
                  Create account
                </lib-signal-button>
              </div>

            </div>
          </form>

          <p class="text-center text-body2 text-slate-500">
            Already have an account?
            <a routerLink="/login" class="font-medium text-primary-600 hover:text-primary-700">
              Sign in
            </a>
          </p>
        </div>
      </div>
    </div>

  </div>
</div>
